module.exports = __webpack_public_path__ + "assets/img/17_1023.3735cdb3.jpg";